var map = {
	"./1.jpeg": 158,
	"./2.png": 586,
	"./3.png": 4691,
	"./4.png": 8444,
	"./5.png": 4357,
	"./6.png": 8606,
	"./7.jpeg": 9040,
	"./8.jpeg": 7485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7548;